import { useParams } from "react-router-dom";

export default function LocationLandingPage() {
  const { slug } = useParams();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white">
        <div className="container mx-auto px-6 py-16">
          <h1 className="text-5xl font-bold">Location: {slug}</h1>
          <p className="text-xl mt-4">
            Location landing page - to be implemented
          </p>
        </div>
      </div>
    </div>
  );
}
